import { createIcon } from '../createIcon.tsx';

export const GarageIcon = createIcon(
	'GarageIcon',
	<>
		<path d="M3 21V8l9-5 9 5v13" />
		<rect x="7" y="13" width="10" height="8" rx="0.5" />
		<line x1="7" y1="17" x2="17" y2="17" />
	</>,
);
